const SquareRadiantDiamonds = ({ ...props }) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
      fill="currentColor"
      {...props}
    >
      <path
        d="M95.59,15.95c0-0.04-0.01-0.08-0.02-0.12c-0.01-0.04-0.03-0.07-0.05-0.11c-0.01-0.02-0.01-0.04-0.02-0.05
	c-0.01-0.02-0.03-0.03-0.04-0.04c-0.01-0.02-0.02-0.03-0.03-0.05l-11-11c-0.01-0.01-0.03-0.02-0.05-0.03
	c-0.02-0.01-0.02-0.03-0.04-0.04c-0.02-0.01-0.04-0.01-0.05-0.02c-0.04-0.02-0.07-0.03-0.11-0.05c-0.04-0.01-0.08-0.02-0.11-0.02
	c-0.02,0-0.04-0.01-0.05-0.01H16c-0.02,0-0.04,0.01-0.05,0.01c-0.04,0-0.08,0.01-0.11,0.02c-0.04,0.01-0.08,0.03-0.11,0.05
	c-0.02,0.01-0.04,0.01-0.05,0.02c-0.02,0.01-0.03,0.03-0.04,0.04c-0.02,0.01-0.04,0.02-0.05,0.03l-11,11
	c-0.01,0.01-0.02,0.03-0.03,0.05c-0.01,0.02-0.03,0.02-0.04,0.04c-0.01,0.02-0.01,0.04-0.02,0.05c-0.02,0.04-0.03,0.07-0.05,0.11
	c-0.01,0.04-0.02,0.07-0.02,0.11c0,0.02-0.01,0.04-0.01,0.05v68c0,0.02,0.01,0.04,0.01,0.05c0,0.04,0.01,0.08,0.02,0.11
	c0.01,0.04,0.03,0.08,0.05,0.11c0.01,0.02,0.01,0.04,0.02,0.05c0.01,0.01,0.02,0.02,0.03,0.03c0.01,0.02,0.02,0.04,0.04,0.06l11,11
	c0.01,0.01,0.03,0.02,0.05,0.03c0.02,0.01,0.02,0.03,0.04,0.04c0.01,0.01,0.03,0,0.04,0.01c0.09,0.05,0.19,0.09,0.29,0.09
	c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0h68c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0.11,0,0.2-0.04,0.29-0.09
	c0.01-0.01,0.03,0,0.04-0.01c0.02-0.01,0.03-0.03,0.04-0.04c0.02-0.01,0.03-0.02,0.05-0.03l11-11c0.02-0.02,0.02-0.04,0.04-0.06
	c0.01-0.01,0.03-0.02,0.04-0.03c0.01-0.02,0.01-0.04,0.02-0.05c0.02-0.04,0.03-0.07,0.05-0.11c0.01-0.04,0.02-0.08,0.02-0.12
	c0-0.02,0.01-0.04,0.01-0.05V16C95.6,15.98,95.59,15.96,95.59,15.95z M84.09,94.06l-3.32-4.98l8.3-8.3l4.98,3.32L84.09,94.06z
	 M17.12,94.4l3.2-4.8h59.36l3.2,4.8H17.12z M5.94,84.09l4.98-3.32l8.3,8.3l-3.32,4.98L5.94,84.09z M5.6,17.12l4.8,3.2v59.36
	l-4.8,3.2V17.12z M15.91,5.94l3.32,4.98l-8.3,8.3l-4.98-3.32L15.91,5.94z M82.88,5.6l-3.2,4.8H20.32l-3.2-4.8H82.88z M94.06,15.91
	l-4.98,3.32l-8.3-8.3l3.32-4.98L94.06,15.91z M24.09,88.4L50,80.63l25.91,7.77H24.09z M75.91,11.6L50,19.37L24.09,11.6H75.91z
	 M77.44,77.44L50,79.4l-27.44-1.96L20.6,50l1.96-27.44L50,20.6l27.44,1.96L79.4,50L77.44,77.44z M77.51,21.36l-24.2-1.73l25.93-7.78
	L77.51,21.36z M22.49,21.36l-1.73-9.51l25.93,7.78L22.49,21.36z M19.63,46.69l-7.78-25.93l9.51,1.73L19.63,46.69z M21.36,77.51
	l-9.51,1.73l7.78-25.93L21.36,77.51z M22.49,78.64l24.2,1.73l-25.93,7.78L22.49,78.64z M77.51,78.64l1.73,9.51l-25.93-7.78
	L77.51,78.64z M80.37,53.31l7.78,25.93l-9.51-1.73L80.37,53.31z M78.64,22.49l9.51-1.73l-7.78,25.93L78.64,22.49z M78.75,21.25
	l1.64-9.02l7.38,7.38L78.75,21.25z M21.26,21.25l-9.02-1.64l7.38-7.38L21.26,21.25z M11.6,24.09L19.37,50L11.6,75.91V24.09z
	 M21.26,78.75l-1.64,9.02l-7.38-7.38L21.26,78.75z M78.75,78.75l9.02,1.64l-7.38,7.38L78.75,78.75z M88.4,75.91L80.63,50l7.77-25.91
	V75.91z M89.6,79.68V20.32l4.8-3.2v65.76L89.6,79.68z"
      />
    </svg>
  )
}

export default SquareRadiantDiamonds
